<script lang="ts">
    import { calcComissionPayable } from '../../../modules/use-cases/calc-comission'
    import { onMount } from 'svelte'
    import DateSelect from '../../_common/date-select.svelte'
    import { GridClass, GridCol, GridColTypeEnum, GridLine } from '../../_common/z/zgrid'
    import Grid from '../../_common/z/zgrid.svelte'
    import type { Invoice } from '../../../modules/posApi/invoices/invoice'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import dayjs from 'dayjs'
    import 'dayjs/locale/pt-br'
    dayjs.locale('pt-br')

    interface SaleRow {
        date: Date
        gross: number
        discount: number
        fees: number
        commission: number
        net: number
    }

    let dateSelect: { from: Date; to: Date } = window.api.utils.dates.today()

    onMount(() => {
        load(dateSelect.from, dateSelect.to)
    })

    let show = false
    let groupByDay = false

    let rows: SaleRow[] = []
    let grid: GridClass = null

    async function load(from: Date, to: Date) {
        if (show) return
        show = true
        let data: Invoice[] = await window.api.pos.invoices.getAll({ from, to, service: true })
        console.log('relat.data', data)
        rows = data.map((invoice) => {
            const services = invoice.services || []
            const gross = services.reduce((total, el) => total + (el.valueTable || el.value || 0) * (el.quantity || 0), 0)
            const netOfDiscounts = services.reduce((total, el) => total + (el.value || 0) * (el.quantity || 0), 0)
            const discount = gross - netOfDiscounts
            const fees = (invoice.payments || []).reduce((total, pm) => total + pm.feeFixed + (pm.value / 100) * pm.feePercentage, 0)
            const commission = services.reduce(
                (total, el) => total + calcComissionPayable(el),
                0,
            )
            const net = netOfDiscounts - fees - commission
            return { date: invoice.createdAt, gross, discount, fees, commission, net }
        })
        loadGrid()
        show = false
    }

    function groupRowsByDay(items: SaleRow[]): SaleRow[] {
        const grouped = new Map<string, SaleRow>()
        for (const row of items) {
            const key = dayjs(row.date).format('YYYY-MM-DD')
            let acc = grouped.get(key)
            if (!acc) {
                acc = { date: dayjs(row.date).startOf('day').toDate(), gross: 0, discount: 0, fees: 0, commission: 0, net: 0 }
                grouped.set(key, acc)
            }
            acc.gross += row.gross
            acc.discount += row.discount
            acc.fees += row.fees
            acc.commission += row.commission
            acc.net += row.net
        }
        return [...grouped.values()].sort((a, b) => a.date.getTime() - b.date.getTime())
    }

    function loadGrid() {
        grid = new GridClass()
        grid.title = 'Vendas por período'
        grid.cols.push(new GridCol({ content: 'Data', type: groupByDay ? GridColTypeEnum.date : GridColTypeEnum.datetime }))
        grid.cols.push(new GridCol({ content: 'Bruto', type: GridColTypeEnum.float_2, showTotal: true }))
        grid.cols.push(new GridCol({ content: 'Desc/Acresc.', type: GridColTypeEnum.float_2, showTotal: true }))
        grid.cols.push(new GridCol({ content: 'Vlr Venda', type: GridColTypeEnum.float_2, showTotal: true }))
        grid.cols.push(new GridCol({ content: 'Taxas', type: GridColTypeEnum.float_2, showTotal: true }))
        grid.cols.push(new GridCol({ content: 'Comissão', type: GridColTypeEnum.float_2, showTotal: true }))
        grid.cols.push(new GridCol({ content: 'Líquido', type: GridColTypeEnum.float_2, showTotal: true }))

        console.log('lines', rows)
        const lines = (groupByDay ? groupRowsByDay(rows) : rows).filter((row) => row.gross !== 0)
        for (const row of lines) {
            let line: GridLine = new GridLine()
            line.slots.push({ content: row.date })
            line.slots.push({ content: row.gross })
            line.slots.push({ content: -row.discount })
            line.slots.push({ content: row.gross - row.discount })
            line.slots.push({ content: -row.fees })
            line.slots.push({ content: -row.commission })
            line.slots.push({ content: row.net })
            grid.lines.push(line)
        }
        console.log('relat.grid', grid)
        grid = grid
    }

    function dateChanged(event) {
        dateSelect = event.detail
        load(dateSelect.from, dateSelect.to)
    }

    function toggleGroupByDay() {
        loadGrid()
    }
</script>

<div class="relat-body">
    <div class="acts h-print d-flex">
        <div class="date">
            <DateSelect on:change={dateChanged} />
        </div>
        <div class="spacer"></div>
        <div>
            <Zinput type="toggle" on:change={toggleGroupByDay} bind:value={groupByDay} label="Agrupar por dia"></Zinput>
        </div>
    </div>
    <div class="grid mt-2">
        <Grid {grid} />
    </div>
</div>
<LoadSpinner {show}></LoadSpinner>
